<template>
  <div>
    <div style="display: flex; align-items: flex-start">
      <sidebar style="margin-right: 20px; max-width: 200px" />
      <el-card style="width: 100%">
        <div
          slot="header"
          class="clearfix"
        >
          <span>Irattípusok</span>
          <el-button
            style="float: right; margin-top: -5px;"
            type="success"
            size="small"
            @click="$router.replace('/docket/document-types/add')"
            icon="el-icon-plus"
            v-can="'documenttype.create'"
          >
            Új Irattípus
          </el-button>
        </div>
        <table-filter
          v-if="config"
          :config="config"
          action="documentType/fetchAll"
        />
        <list/>
        <template v-if="$route.meta.showAddDocumentTypeDialog">
          <document-type-dialog
            type="add"
          />
        </template>
        <template v-if="$route.meta.showUpdateDocumentTypeDialog">
          <document-type-dialog
            :document-type-id="$route.params.id"
            type="update"
          />
        </template>
      </el-card>
    </div>
  </div>
</template>
<script>
  import Sidebar from '../../components/docket/Sidebar';
  import List from '../../components/docket/documentTypes/List';
  import DocumentTypeDialog from '../../components/docket/documentTypes/Dialog';
  import TableFilter from '../../components/TableFilter';

  export default {
    components: {
      Sidebar,
      List,
      DocumentTypeDialog,
      TableFilter,
    },
    data() {
      return {
        config: null,
      };
    },
    methods: {
      async setConfig() {

        this.config = [
          {
            type: 'text',
            name: 'name',
            label: 'Név',
            defaultSearch: true
          },
        ];
      }
    },
    async mounted() {
      await this.setConfig();
    }
  };
</script>
